import { createSlice } from '@reduxjs/toolkit';

export interface AuthState {
    token: string | undefined;
}

const initialState: AuthState = {
    token: undefined
};

export const authSlice = createSlice({
    name: 'authState',
    initialState,
    reducers: {
        setToken: (state: AuthState, action) => {
            state.token = action.payload;
        },
        
    }
})

export const { setToken } = authSlice.actions;
export default authSlice.reducer;